import { useState } from "react"

// Owns the award form's values and the fetch submission lifecycle
// (idle → submitting → success). Everything is a chip choice with a default, so
// there is nothing to validate client-side. `getFile` returns the currently
// chosen photo file (managed outside, by useCoverPreview).
const useAwardForm = (config, getFile) => {
  const [values, setValues] = useState({
    kind: config.award.kind || "medal",
    direction: config.award.direction || "other",
    place: config.award.place ? String(config.award.place) : "",
  })
  const [status, setStatus] = useState("idle") // idle | submitting | success
  const [formError, setFormError] = useState(null)
  const [shake, setShake] = useState(false)

  const change = (name, value) => {
    setValues((v) => ({ ...v, [name]: value }))
  }

  const submit = async (e) => {
    e.preventDefault()
    if (status !== "idle") return

    setStatus("submitting")
    setFormError(null)

    const fd = new FormData()
    fd.append("award[kind]", values.kind)
    fd.append("award[direction]", values.direction)
    fd.append("award[place]", values.place) // "" → nil on the integer column
    const file = getFile()
    if (file) fd.append("award[photo]", file)
    if (config.method === "patch") fd.append("_method", "patch")

    try {
      const res = await fetch(config.action, {
        method: "POST",
        headers: { "X-CSRF-Token": config.csrf, Accept: "application/json" },
        body: fd,
      })
      const data = await res.json().catch(() => ({}))

      if (res.ok && data.ok) {
        setStatus("success")
        setTimeout(() => {
          if (window.Turbo) window.Turbo.visit(data.redirect)
          else window.location.href = data.redirect
        }, 750)
      } else {
        setFormError("Не вдалося зберегти. Спробуй ще раз.")
        setStatus("idle")
        setShake(true)
        setTimeout(() => setShake(false), 500)
      }
    } catch (err) {
      setFormError("Не вдалося зберегти. Перевір зʼєднання і спробуй ще раз.")
      setStatus("idle")
    }
  }

  return { values, status, formError, shake, change, submit }
}

export default useAwardForm
